var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSandals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.728 14.727H22.46c-.067-1.623-.727-2.696-1.287-3.318-.643-.717-1.287-1.01-1.314-1.022l-.003-.001-.004-.001-3.26-1.363V9.02a.272.272 0 00-.244.018l-9.446 5.688h-5.63A.272.272 0 001 15v2.728c0 .15.122.273.272.273h24.456c.15 0 .272-.123.272-.273v-2.728a.273.273 0 00-.272-.272zm-4.941-2.935c.7.79 1.079 1.777 1.13 2.935h-7.069l4.93-3.768c.378.221.718.503 1.009.833zm4.669 5.662H1.544v-2.182h23.912v2.182z",
    fill: "#000",
    fillRule: "nonzero"
  })));
}

export default SvgSandals;